import { QidCompany } from "server/models"
import { PublishedUnpublished, OrderType } from "client/utils"


export interface QidCompanyProps {
    companyId: number
    hash?: string
}

export interface QidCompanyList { [companyId: number]: QidCompany }
export interface QidCompanyFilters {
    status?: PublishedUnpublished
    search?: string
}

export type QidCompanyValidation = { [key in keyof QidCompany]?: string}

export interface QidCompanyState {
    companyList: QidCompanyList
    companyIds: readonly number[]
    companyView: QidCompany
    companyEdit: QidCompany

    sortColumn: keyof QidCompany
    sortOrder: OrderType
    filters: QidCompanyFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const QID_COMPANY_LIST = "QID_COMPANY_LIST"
export const QID_COMPANY_IDS = "QID_COMPANY_IDS"
export const QID_COMPANY_VIEW = "QID_COMPANY_VIEW"
export const QID_COMPANY_EDIT = "QID_COMPANY_EDIT"

export const QID_COMPANY_SORT = "QID_COMPANY_SORT"
export const QID_COMPANY_FILTERS = "QID_COMPANY_FILTERS"

export const QID_COMPANY_RELOAD_LIST = "QID_COMPANY_RELOAD_LIST"
export const QID_COMPANY_RELOAD_VIEW = "QID_COMPANY_RELOAD_VIEW"
export const QID_COMPANY_RELOAD_EDIT = "QID_COMPANY_RELOAD_EDIT"
